"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cnbuilder = require("cnbuilder");
var _IconButtonModule = _interopRequireDefault(require("./IconButton.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["className", "testAttr", "children", "i18nLabel", "href", "isProminent", "size", "disabled", "onClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const IconButton = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
      className,
      testAttr,
      children,
      i18nLabel,
      href,
      isProminent,
      size,
      disabled,
      onClick
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return href ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", _objectSpread(_objectSpread({
    ref: ref,
    className: (0, _cnbuilder.cnb)(_IconButtonModule.default.root, {
      [_IconButtonModule.default.prominent]: isProminent
    }, {
      [_IconButtonModule.default.disabled]: disabled
    }, {
      [_IconButtonModule.default[size]]: size
    }, className),
    "aria-label": i18nLabel,
    "data-testid": testAttr,
    href: href,
    onClick: onClick
  }, rest), {}, {
    children: children
  })) : /*#__PURE__*/(0, _jsxRuntime.jsx)("button", _objectSpread(_objectSpread({
    ref: ref,
    className: (0, _cnbuilder.cnb)(_IconButtonModule.default.root, {
      [_IconButtonModule.default.prominent]: isProminent
    }, {
      [_IconButtonModule.default[size]]: size
    }, className),
    "aria-label": i18nLabel,
    "data-testid": testAttr,
    type: "button",
    disabled: disabled,
    onClick: onClick
  }, rest), {}, {
    children: children
  }));
});
IconButton.propTypes = {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,
  /** The name of the test attribute to associate to the component. */
  testAttr: _propTypes.default.string,
  /** The icon to insert into the button. */
  children: _propTypes.default.node.isRequired,
  /** The url used to render an anchor tag instead of a button. */
  href: _propTypes.default.string,
  /** The aria-label to apply to the button element. */
  i18nLabel: _propTypes.default.string.isRequired,
  /** Whether the button has prominent styling applied (border, background, and elevation). */
  isProminent: _propTypes.default.bool,
  /** The size of the button. */
  size: _propTypes.default.oneOf(['sm', 'md']),
  /** Whether the button is disabled or not. */
  disabled: _propTypes.default.bool,
  /**
   * The handler to execute when the button is clicked.
   *
   * @param {SyntheticEvent} evt - The React `SyntheticEvent`.
   */
  onClick: _propTypes.default.func
};
IconButton.defaultProps = {
  testAttr: 'icon-button',
  size: 'sm'
};
var _default = exports.default = IconButton;